import classNames from 'classnames';
import { FC, useState } from 'react';

export const ColorPalette: FC<{
  colors: string[];
  onDragStart: (color: string) => void;
}> = ({ colors, onDragStart }) => {
  const [draggedColor, setDraggedColor] = useState<string | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="grid grid-cols-8 gap-3 mb-6">
      {colors.map((color, index) => (
        <div
          key={color}
          className="relative"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex((prev) => (prev === index ? null : prev))}
        >
          <div
            draggable
            onDragStart={() => {
              setHoveredIndex(null);
              setDraggedColor(color);
              onDragStart(color);
            }}
            onDragEnd={() => setDraggedColor(null)}
            className={classNames(
              'w-full aspect-[3/4] rounded-control cursor-grab transition-transform duration-200 hover:scale-110 active:scale-95 hover-glow',
            )}
            style={{ backgroundColor: color }}
          />

          {hoveredIndex === index &&
            (() => {
              const shouldFlipLeft = colors.length >= 5 && index >= colors.length - 2;

              return (
                <div
                  className={classNames(
                    'absolute top-1/2 -translate-y-1/2 bg-ink text-white text-ui-xs-strong px-3 py-2 rounded-control shadow-popup w-[160px] z-10 pointer-events-none',
                    shouldFlipLeft ? 'right-full mr-3' : 'left-full ml-3',
                  )}
                >
                  Перетащите карточку в окошко ниже
                  <span
                    className={classNames(
                      'absolute top-1/2 -translate-y-1/2 border-[6px] border-transparent pointer-events-none',
                      shouldFlipLeft ? 'left-full border-l-ink' : 'right-full border-r-ink',
                    )}
                  />
                </div>
              );
            })()}
        </div>
      ))}
    </div>
  );
};
